import { render, staticRenderFns } from "./memberDetail.vue?vue&type=template&id=5f959d44&scoped=true&"
import script from "./memberDetail.vue?vue&type=script&lang=js&"
export * from "./memberDetail.vue?vue&type=script&lang=js&"
import style0 from "./memberDetail.vue?vue&type=style&index=0&id=5f959d44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f959d44",
  null
  
)

export default component.exports